import React from 'react';
import Svg, { Circle, Path } from 'react-native-svg';

interface AlertIconProps {
  size?: number;
  color?: string;
}

const AlertIcon: React.FC<AlertIconProps> = ({ size = 48, color = '#FF7B7E' }) => (
  <Svg width={size} height={size} viewBox="0 0 48 48" fill="none">
    <Circle cx="24" cy="24" r="24" fill={color} />
    <Path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M23.7165 28.0027C23.2328 28.0098 22.749 28.0279 22.2656 28.0212C21.4534 28.0099 21.0211 27.5863 21.0074 26.7749C20.9934 25.9479 21.0036 25.1205 21.0036 24.2932C21.0036 20.7188 21.0031 17.1443 21.0038 13.5698C21.0039 12.4081 21.379 12.0315 22.5452 12.0222C22.904 12.0194 23.2627 12.0255 23.6214 12.0275C24.289 12.5992 24.2937 13.3635 24.2905 14.1592C24.2747 18.0163 24.2781 21.8735 24.2877 25.7307C24.2896 26.5433 24.3504 27.3564 23.7165 28.0027Z"
      fill="white"
    />
    <Path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M23.7162 28.0026C24.3502 27.3563 24.2895 26.5432 24.2874 25.7308C24.2778 21.8737 24.2745 18.0164 24.2902 14.1593C24.2933 13.3637 24.2887 12.5993 23.6211 12.0276C24.0891 12.019 24.5583 11.9856 25.0248 12.0071C25.822 12.0439 26.2487 12.503 26.2503 13.3026C26.2547 15.5678 26.252 17.8329 26.252 20.0982C26.2521 22.2853 26.2534 24.4723 26.2514 26.6594C26.2504 27.6236 25.8486 28.0244 24.8867 28.0231C24.4965 28.0224 24.1064 28.0097 23.7162 28.0026Z"
      fill="white"
    />
    <Path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M23.1549 36.661C21.8888 36.4011 21.0186 35.3743 21.0089 34.1283C20.9989 32.8371 21.8828 31.808 23.2475 31.5215C23.3927 31.6314 23.5283 31.7581 23.6848 31.8483C24.7595 32.4678 25.234 33.6535 24.9029 34.845C24.6446 35.773 23.9678 36.2776 23.1549 36.661Z"
      fill="white"
    />
    <Path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M23.1543 36.6607C23.9673 36.2774 24.6441 35.7727 24.9022 34.8447C25.2334 33.6532 24.7588 32.4675 23.6842 31.848C23.5277 31.7576 23.392 31.631 23.2469 31.5212C24.7054 31.2766 25.9951 32.3139 26.2308 33.7188C26.4562 35.0624 25.5539 36.3627 24.1618 36.6737C23.8428 36.7447 23.4909 36.6688 23.1543 36.6607Z"
      fill="white"
    />
  </Svg>
);

export default AlertIcon;
